import { useCallback, useState } from 'react'
import type { BrowsePreset } from '../components/MarketplaceHome'

export type CatalogSort = 'newest' | 'price_asc' | 'price_desc' | 'model'

export type CatalogFilterState = {
  q: string
  city: string
  condition: string
  warranty: '' | 'yes' | 'no'
  usage: string
  batteryMin: '' | '80' | '90' | '95'
  inBox: string
  priceMin: string
  priceMax: string
  yearFrom: string
  yearTo: string
  sortBy: CatalogSort
}

const EMPTY: CatalogFilterState = {
  q: '',
  city: '',
  condition: '',
  warranty: '',
  usage: '',
  batteryMin: '',
  inBox: '',
  priceMin: '',
  priceMax: '',
  yearFrom: '',
  yearTo: '',
  sortBy: 'newest',
}

export function useCatalogFilters() {
  const [filters, setFilters] = useState<CatalogFilterState>(EMPTY)

  const patch = useCallback((next: Partial<CatalogFilterState>) => {
    setFilters((f) => ({ ...f, ...next }))
  }, [])

  const applyPreset = useCallback((preset: BrowsePreset | null) => {
    if (!preset) return
    setFilters((f) => ({
      ...f,
      q: preset.q ?? f.q,
      condition: preset.condition ?? f.condition,
      warranty: preset.warranty ?? f.warranty,
      usage: preset.usage ?? f.usage,
    }))
  }, [])

  const clearAll = useCallback(() => {
    setFilters(EMPTY)
  }, [])

  const hasActiveFilters =
    Boolean(filters.q.trim()) ||
    Boolean(filters.city) ||
    Boolean(filters.condition) ||
    Boolean(filters.warranty) ||
    Boolean(filters.usage) ||
    Boolean(filters.batteryMin) ||
    Boolean(filters.inBox) ||
    Boolean(filters.priceMin.trim()) ||
    Boolean(filters.priceMax.trim()) ||
    Boolean(filters.yearFrom.trim()) ||
    Boolean(filters.yearTo.trim())

  return { filters, patch, applyPreset, clearAll, hasActiveFilters }
}
